export default __webpack_public_path__ + "static/media/img07.e21adf8e.jpg";